/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice\src\Content\Offers\OfferFiles\OfferFilesRow.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice
 * Created Date: Friday October 11th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday October 11th 2024 1:55:30 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { TableRow, TableCell, Button } from "@mui/material";
import { OfferFileType } from "Types/offer.type";
import Styles from "Content/Cart/OfferFiles/OfferFileRow.module.css";

type OfferFileProps = {
    file: OfferFileType
};

export default function OfferFilesRow(props: OfferFileProps) {
    return (
        <TableRow key={props.file.id}>
            <TableCell>
                <Button>
                    <a className={`${Styles.link}`} target={"_blank"} href={props.file.URI}>
                        {props.file.Name}
                    </a>
                </Button>
            </TableCell>
        </TableRow>
    );
};
